












import { Component, Prop, Vue } from 'vue-property-decorator';

import CloseIcon from '@/components/icons/Close.vue';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';

import eventBus from '@/utils/eventBus';
import BusinessService from '@/api/BusinessService';
import flagKeys from '@/constants/flagKeys';

import { ETutorial } from '@/models/tutorial';

import Introduction from './Steps/Introduction.vue';
import Confirmation from './Steps/Confirmation.vue';
import FeedbackStatus from './Steps/FeedbackStatus.vue';
import segmentIo from '@/utils/segment.io';

export type OnlineInStoreNextParams = {
  redirectToSlug: string;
};

export enum EOnlineInStoreStepSlug {
  INTRODUCTION = 'introduction',
  CONFIRMATION = 'confimation',
  FEEDBACK_STATUS = 'feedback-status'
}

@Component({
  components: {
    CloseIcon,
    Introduction,
    Confirmation,
    FeedbackStatus
  }
})
export default class OnlineInStoreModal extends Vue {
  @Prop() notShowNotificationArrow?: boolean;

  @Prop() byBanner?: boolean;

  service = new BusinessService();

  activeStepSlug: string = EOnlineInStoreStepSlug.INTRODUCTION;

  get getFlags() {
    return this.$store.getters['flags/getFlags'];
  }

  get showFeedbackModal() {
    return (
      this.getFlags.includes(flagKeys.feedbackPlatform) && this.currentProvider
    );
  }

  get isImpersonated() {
    return this.$store.getters['manager/isImpersonated'];
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get componentByStepSlug(): {
    [k: string]: {
      component: string;
    };
  } {
    return {
      [EOnlineInStoreStepSlug.INTRODUCTION]: {
        component: 'Introduction'
      },
      [EOnlineInStoreStepSlug.CONFIRMATION]: {
        component: 'Confirmation'
      },
      [EOnlineInStoreStepSlug.FEEDBACK_STATUS]: {
        component: 'FeedbackStatus'
      }
    };
  }

  get analyticsOrigin() {
    let origin = 'Access Dashboard';

    if (this.byBanner) origin = 'Banner';
    else if (this.$route.params.email) origin = 'Email';
    return origin;
  }

  handleGoToStep({ redirectToSlug }: OnlineInStoreNextParams) {
    segmentIo.track('Changed Step Activate Physical_Online Rewards', {
      'Actual Step': this.activeStepSlug,
      'Go To Step': redirectToSlug,
      Origin: this.analyticsOrigin
    });
    this.activeStepSlug = redirectToSlug;
  }

  onClose() {
    eventBus.$emit('closeModal');

    if (this.business.showPlatformFeedback && this.showFeedbackModal) {
      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: 'feedbackModal',
          hideCancelButton: false,
          icon: '',
          mobilePositionBottom: true,
          mobileFullScreen: false
        })
      );
    } else if (
      !this.business.seenInStoreOnlineRewardWhatsNew &&
      this.activeStepSlug !== EOnlineInStoreStepSlug.FEEDBACK_STATUS &&
      !this.notShowNotificationArrow
    )
      setTimeout(() => {
        eventBus.$emit('showNotificationOnNavItem', {
          link: '',
          groupId: 'my-tools',
          subGroupId: 'loyalty-program',
          title:
            'Activate consumer rewards for Online and In-Store channels within any tab of the Loyalty Program menu.',
          learnMoreLink: 'https://support.twism.com/hc/en-us',
          learnMoreClick: () => {
            segmentIo.track('Clicked Support Link Physical_Online Rewards', {
              Origin: 'Menu Tooltip'
            });
          }
        });
      }, 250);
  }

  async created() {
    if (!this.business.seenInStoreOnlineRewardWhatsNew && !this.isImpersonated)
      await this.service.updateBusinessFlagTutorial({
        state: true,
        flag: ETutorial.SEEN_INSTORE_ONLINE_REWARD
      });

    segmentIo.modal('Activate Physical_Online Rewards', {
      Origin: this.analyticsOrigin
    });
  }

  destroyed() {
    if (!this.business.seenInStoreOnlineRewardWhatsNew)
      this.$store.dispatch('business/SET_BUSINESS_INFO', {
        ...this.business,
        seenInStoreOnlineRewardWhatsNew: true
      });
  }
}
